import { useEffect, useState } from 'react';
import {
    Button,
    Box,
    Stack,
    Typography,
    FormControl,
    TextField,
} from '@mui/material';
import { SelectAllFromTable, SelectGenericFromTable, SelectRowFromTable } from '../universal/Axios';
import apiClient from '../../apiClient';
import { getStore } from '../../Store'
import { DNCParamTable } from './DNCParamTable';

const store = getStore();

const EditDNCParam = () => {
    const queryParameters = new URLSearchParams(window.location.search)
    const id = queryParameters.get("id")
    const [existingParameterSetObject, setExistingParameterSetObject] = useState(null)
    const [parameterSetID, setDNCParamID] = useState(id !== null ? id : "")
    const [description, setDescription] = useState("")
    const [passedParameterSetDncParamParameterSetMappings, setPassedParameterSetDncParamParameterSetMappings] = useState([])
    const [selectedDNCParams, selectDNCParam] = useState([])
    const [existingDncParamParameterSetMappings, setExistingDncParamParameterSetMappings] = useState([])
    const [existingParameterSets, setExistingParameterSets] = useState([])
    const [existingIDs, setExistingIDs] = useState([])
    const [errorMessages, setErrorMessages] = useState({});
    const [identicalParameterSetExists, setIdenticalParameterSetExists] = useState(false)
    const [isSubmitButtonDisabled, setSubmitButtonDisabled] = useState(true)

    useEffect(() => {
        SelectGenericFromTable("select id from parameter_set;", setExistingIDs)
        SelectGenericFromTable("select * from parameter_set ps JOIN dnc_param_parameter_set_mapping dppsm on ps.id = dppsm.parameter_set_id;", setExistingDncParamParameterSetMappings)
        if (id !== null) {
            SelectRowFromTable("select * from parameter_set where id = '" + id + "';", setExistingParameterSetObject)
            SelectGenericFromTable("select * from dnc_param_parameter_set_mapping where parameter_set_id = '" + id + "';", setPassedParameterSetDncParamParameterSetMappings)
        }
    }, []);

    useEffect(() => {
        if (selectedDNCParams.length === 0) {
            setIdenticalParameterSetExists(false)
        }
        else if (existingParameterSets !== null) {
            let potentialMatches = existingParameterSets.filter(x => x.dnc_params.length === selectedDNCParams.length)
            let match_exists = false;
            console.log(potentialMatches)
            for (let i = 0; i < potentialMatches.length; i++) {

                let match = true
                for (let j = 0; j < selectedDNCParams.length; j++) {
                    if (potentialMatches[i].dnc_params.indexOf(selectedDNCParams[j]) === -1) {
                        match = false
                    }
                }
                if (match) {
                    match_exists = true;
                }
            }
            setIdenticalParameterSetExists(match_exists)
        }
    }, [selectedDNCParams])

    useEffect(() => {
        let tempExistingParameterSetMappings = []
        for (let i = 0; i < existingIDs.length; i++)
        {
            let tempExistingParameterSetMapping = { id: existingIDs[i] }
            let parameterSetMappings = existingDncParamParameterSetMappings.filter(x => x.id === existingIDs[i]["id"])
            let tempDNCParams = []
            for (let j = 0; j < parameterSetMappings.length; j++)
            {
                tempDNCParams.push(parameterSetMappings[j].dnc_param_id)
            }
            tempExistingParameterSetMapping["dnc_params"] = tempDNCParams
            tempExistingParameterSetMappings.push(tempExistingParameterSetMapping)
        }
        setExistingParameterSets(tempExistingParameterSetMappings)
    }, [existingDncParamParameterSetMappings])

    useEffect(() => {
        if (existingParameterSetObject !== null) {
            if (existingParameterSetObject.description !== undefined) {
                setDescription(existingParameterSetObject.description)
            }

        }
    }, [existingParameterSetObject])

    useEffect(() => {
        validateForm()
    }, [parameterSetID, identicalParameterSetExists, selectedDNCParams])

    const checkSubmitButtonDisabled = () => {
        const has_errors = Object.keys(errorMessages).map(x => errorMessages[x]).some(x => x !== "")
        setSubmitButtonDisabled(has_errors)
    }

    useEffect(() => {
        checkSubmitButtonDisabled()
    }, [errorMessages])

    const validateForm = () => {
        //ID Section
        if (existingIDs.map(x => x["id"]).indexOf(parameterSetID) === -1 || id !== null) {
            setErrorMessages(errorMessages => ({ ...errorMessages, ["uniqueness"]: "" }))
        }
        else {
            setErrorMessages(errorMessages => ({ ...errorMessages, ["uniqueness"]: "A parameter set with that ID already exists" }))
        }

        if (parameterSetID === "") {
            setErrorMessages(errorMessages => ({ ...errorMessages, ["has_id"]: "No ID" }))
        }
        else {
            setErrorMessages(errorMessages => ({ ...errorMessages, ["has_id"]: "" }))
        }

        if (selectedDNCParams.length === 0 && id === null) {
            setErrorMessages(errorMessages => ({ ...errorMessages, ["dnc_param_not_selected"]: "No DNC Params selected" }))
        } else {
            setErrorMessages(errorMessages => ({ ...errorMessages, ["dnc_param_not_selected"]: "" }))
        }

        if (identicalParameterSetExists) {
            setErrorMessages(errorMessages => ({ ...errorMessages, ["identical_parameter_set_exists"]: "Identical parameter set already exists" }))
        }
        else {
            setErrorMessages(errorMessages => ({ ...errorMessages, ["identical_parameter_set_exists"]: "" }))
        }
    }

    const createParameterSet = () => {
        store.updateStatusMessage((id == null ? "Creating " : "Editing ") + " Parameter Set...")
        apiClient.post(
            "https://us-central1-airy-semiotics-297902.cloudfunctions.net/interactive-density-network",
            {
                "function_to_execute": id == null ? "Create_Parameter_Set" : "Edit_Parameter_Set",
                "id": id == null ? parameterSetID : id,
                "description": description,
                "dnc_params": selectedDNCParams
            }
        ).then(() => {
            store.updateSuccessMessage("Successfully " + (id == null ? "created" : "edited") + " Parameter Set!")
            window.location.href = "/parameter-sets"
        }).catch(function (error) {
            if (error?.response?.status === 401) {
                //handleautherror(dispatch)
            } else {

            }
        });
    }

    return (
        <>
            <Typography variant="h5">{id == null ? "Create" : "Edit"} Parameter Set</Typography>
            {errorMessages["has_id"] !== undefined && <Typography color="red">{errorMessages["has_id"]}</Typography>}
            {errorMessages["uniqueness"] !== undefined && <Typography color="red">{errorMessages["uniqueness"]}</Typography>}
            {errorMessages["identical_parameter_set_exists"] !== undefined && <Typography color="red">{errorMessages["identical_parameter_set_exists"]}</Typography>}
            {errorMessages["dnc_param_not_selected"] !== undefined && <Typography color="red">{errorMessages["dnc_param_not_selected"]}</Typography>}
            <Box sx={{ height: '80px', marginTop: '20px' }}>
                <FormControl style={{ width: '45%', marginRight: '20px', marginBottom: '25px' }}>
                    <TextField
                        id="id"
                        label="Parameter Set ID"
                        onChange={(event) => setDNCParamID(event.target.value)}
                        required
                        value={id !== null ? id : parameterSetID}
                        readOnly={id !== null}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                </FormControl>
                <FormControl style={{ width: '45%' }}>
                    <TextField
                        id="description"
                        label="Description"
                        onChange={(event) => setDescription(event.target.value)}
                        value={description}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                </FormControl>
            </Box>
            {id === null && <DNCParamTable selectable={true} selectedDNCParams={selectedDNCParams} selectDNCParam={selectDNCParam} />}
            {id !== null && <>DNC Params: <h2>{passedParameterSetDncParamParameterSetMappings.map(x => x.dnc_param_id).join(", \n")}</h2></>}
            <Box sx={{ m: 2, height: '10px' }}>
                <Box style={{ width: '90%', height: '10px', display: 'inline-block', float: 'left' }}>
                    <Box sx={{ m: 2 }}>
                        <Stack direction="row" spacing={1} justifyContent="flex-end">
                            <Button variant="outlined" href={"parameter-sets"}>Cancel</Button>
                            <Button variant="outlined" onClick={() => createParameterSet()} disabled={isSubmitButtonDisabled}>Submit</Button>
                        </Stack>
                    </Box>
                </Box>
            </Box>
        </>
    )
}

export default EditDNCParam;
